import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Menu,
  Search,
  Bell,
  Settings,
  User,
  LogOut,
  Sun,
  Moon,
  ChevronDown,
} from "lucide-react";
import { useAuth } from "../../hooks/use-auth";
import { getInitials, getAvatarColor, getPhotoUrl } from "../../lib/utils";
import { Link } from "react-router-dom";

export default function Navbar({
  user,
  sidebarOpen,
  setSidebarOpen,
  isDarkMode,
  toggleTheme,
}) {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <nav className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left Section */}
          <div className="flex items-center space-x-4">
            {/* Mobile Menu Button */}
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="lg:hidden p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <Menu className="h-5 w-5" />
            </button>

            {/* Search Bar */}
            {/* <div className="hidden md:block relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-4 w-4 text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Rechercher..."
                className="pl-10 pr-4 py-2 w-64 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              />
            </div> */}
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-4">
            {/* Theme Toggle */}
            {/* <button
              onClick={toggleTheme}
              className="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              {isDarkMode ? (
                <Sun className="h-5 w-5" />
              ) : (
                <Moon className="h-5 w-5" />
              )}
            </button> */}

            {/* Notifications */}
            <div className="relative">
              {/* <button
                onClick={() => setNotificationsOpen(!notificationsOpen)}
                className="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 relative"
              >
                <Bell className="h-5 w-5" />
                
                <span className="absolute -top-1 -right-1 h-4 w-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                  3
                </span>
              </button> */}

              {/* Notifications Dropdown */}
              {notificationsOpen && (
                // <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
                //   <div className="p-4 border-b border-gray-200 dark:border-gray-700">
                //     <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                //       Notifications
                //     </h3>
                //   </div>
                //   <div className="max-h-96 overflow-y-auto">
                //     {/* Sample Notifications */}
                //     <div className="p-4 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-600">
                //       <p className="text-sm font-medium text-gray-900 dark:text-white">
                //         Nouvelle demande de congé
                //       </p>
                //       <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                //         Marie Dupont a soumis une demande de congé
                //       </p>
                //       <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">
                //         Il y a 2 heures
                //       </p>
                //     </div>
                //     <div className="p-4 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-600">
                //       <p className="text-sm font-medium text-gray-900 dark:text-white">
                //         Rapport mensuel disponible
                //       </p>
                //       <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                //         Le rapport de présence de novembre est prêt
                //       </p>
                //       <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">
                //         Il y a 1 jour
                //       </p>
                //     </div>
                //   </div>
                //   <div className="p-4 border-t border-gray-200 dark:border-gray-700">
                //     <button className="text-sm text-blue-600 dark:text-blue-400 hover:underline">
                //       Voir toutes les notifications
                //     </button>
                //   </div>
                // </div>
                <></>
              )}
            </div>

            {/* User Profile Menu */}
            <div className="relative">
              <button
                onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                className="flex items-center space-x-3 p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700"
              >
                {/* Avatar */}
                <div className="h-8 w-8 rounded-full overflow-hidden">
                  {user?.photo_profil ? (
                    <img
                      src={getPhotoUrl(user.photo_profil)}
                      alt={`${user.prenom} ${user.nom}`}
                      className="h-8 w-8 rounded-full object-cover"
                    />
                  ) : (
                    <div
                      className="h-8 w-8 rounded-full flex items-center justify-center text-white text-sm font-medium"
                      style={{
                        backgroundColor: getAvatarColor(user?.email || ""),
                      }}
                    >
                      {getInitials(`${user?.prenom || ""} ${user?.nom || ""}`)}
                    </div>
                  )}
                </div>

                {/* User Info */}
                <div className="hidden md:block text-left">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">
                    {user?.prenom} {user?.nom}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {user?.role}
                  </p>
                </div>

                <ChevronDown className="h-4 w-4 text-gray-400" />
              </button>

              {/* Profile Dropdown */}
              {profileMenuOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
                  <div className="p-4 border-b border-gray-200 dark:border-gray-700">
                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                      {user?.prenom} {user?.nom}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      {user?.email}
                    </p>
                  </div>

                  <div className="py-2">
                    <Link
                      to="/dashboard/settings"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                      <User className="h-4 w-4 mr-3" />
                      Mon profil
                    </Link>
                    <Link
                      to="/dashboard/settings"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                      <Settings className="h-4 w-4 mr-3" />
                      Paramètres
                    </Link>
                  </div>

                  <div className="border-t border-gray-200 dark:border-gray-700 py-2">
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-red-700 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700"
                    >
                      <LogOut className="h-4 w-4 mr-3" />
                      {t("auth.logout")}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
